import { render, staticRenderFns } from "./CityView.vue?vue&type=template&id=bb663a10&"
import script from "./CityView.vue?vue&type=script&lang=js&"
export * from "./CityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports